<nb-card>
  <nb-card-header>{{ "excel_dl" | translate }}</nb-card-header>

  @if (!confirmed) {
    <nb-card-body>
      <nb-radio-group>
        <nb-radio>
          {{ "enegy trajectory explanation" | translate }}
        </nb-radio>
        <nb-radio>
          {{ "prefilled CRREM file" | translate }}
        </nb-radio>
      </nb-radio-group>
    </nb-card-body>
  }

  @if (confirmed) {
    <nb-card-body>
      {{ "not Implemented Yet" | translate }}
    </nb-card-body>
  }

  @if (!confirmed) {
    <nb-card-footer>
      <button (click)="validate()">{{ "ok" | translate }}</button>
      <button (click)="close()">{{ "cancel" | translate }}</button>
    </nb-card-footer>
  }

  @if (confirmed) {
    <nb-card-footer>
      <button (click)="close()">{{ "ok" | translate }}</button>
    </nb-card-footer>
  }

</nb-card>

